import z from 'zod'
import { integer, jsonb, pgTable, serial, text, timestamp, boolean } from 'drizzle-orm/pg-core'
import { createSelectSchema } from 'drizzle-zod'

export const zEmailNotifications = z.object({
  scheduledPostReminder: z.boolean(),
  postPublished: z.boolean(),
  postFailed: z.boolean(),
})
export type EmailNotifications = z.infer<typeof zEmailNotifications>

export const defaultEmailNotifications: EmailNotifications = {
  scheduledPostReminder: true,
  postPublished: true,
  postFailed: true,
}

export const providerTypes = ['google', 'userpass'] as const
export const zProviderType = z.enum(providerTypes)
export type ProviderType = z.infer<typeof zProviderType>

export const pgUser = pgTable('user', {
  id: serial('id').primaryKey(),
  email: text('email').notNull().unique(),
  name: text('name'),
  isAdmin: boolean('is_admin').notNull().default(false),

  verified: boolean('verified').notNull(),
  verificationToken: text('verification_token'),

  currentBrandId: integer('current_brand_id').notNull(),

  emailNotifications: jsonb('email_notifications')
    .notNull()
    .default(defaultEmailNotifications)
    .$type<EmailNotifications>(),

  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at').notNull().defaultNow(),
})

export const zUser = createSelectSchema(pgUser).extend({
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type User = z.infer<typeof zUser>

export const pgAuthProvider = pgTable('auth_provider', {
  id: serial('id').primaryKey(),
  userId: integer('user_id')
    .notNull()
    .references(() => pgUser.id, { onDelete: 'cascade' }),

  provider: text('provider', { enum: providerTypes }).notNull(),
  providerUserId: text('provider_user_id').unique().notNull(),

  refreshToken: text('refresh_token'),
  passwordHash: text('password_hash'),

  createdAt: timestamp('created_at').notNull().defaultNow(),
  updatedAt: timestamp('updated_at').notNull().defaultNow(),
})
